<lib-default-control-panel-side-bar
  [desginOptions]="desginOptions"
  [configuration]="configuration"
  [translations]="translations"
  [features]="configFeatures"
  [checkIfEnabledCardPaymentGateway]="checkIfEnabledCardPaymentGateway()"
  [activeFunc]="isActive.bind(this)"
  (delAccountAlert)="deleteAccountAlert()"
  (logOut)="logout()"
></lib-default-control-panel-side-bar>